// extracted by mini-css-extract-plugin
export default {"overlay":"FocusContextRegionProvider_overlay__RuAqB"};